'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import BreakdownScore from './BreakdownScore';
import ScoreConstants from '../constants/ScoreConstants';
export default class BreakdownScoreContainer extends Component {
  render() {
    const {
      websiteGrade
    } = this.props;
    const performanceScore = websiteGrade.performanceAudit.grade;
    const mobileGrade = websiteGrade.mobileAudit.grade;
    const seoGrade = websiteGrade.seoAudit.grade;
    const securityGrade = websiteGrade.securityAudit.grade;
    return /*#__PURE__*/_jsxs("div", {
      className: "breakdown-score-container",
      children: [/*#__PURE__*/_jsx(BreakdownScore, {
        page: "performance",
        score: performanceScore,
        overallScore: ScoreConstants.PERFORMANCE_OVERALL
      }), /*#__PURE__*/_jsx(BreakdownScore, {
        page: "seo",
        score: seoGrade,
        overallScore: ScoreConstants.SEO_OVERALL
      }), /*#__PURE__*/_jsx(BreakdownScore, {
        page: "mobile",
        score: mobileGrade,
        overallScore: ScoreConstants.MOBILE_OVERALL
      }), /*#__PURE__*/_jsx(BreakdownScore, {
        page: "security",
        score: securityGrade,
        overallScore: ScoreConstants.SECURITY_OVERALL
      })]
    });
  }

}